import { render, staticRenderFns } from "./Signitures.vue?vue&type=template&id=1c076efa&scoped=true"
import script from "./Signitures.vue?vue&type=script&lang=js"
export * from "./Signitures.vue?vue&type=script&lang=js"
import style0 from "./Signitures.vue?vue&type=style&index=0&id=1c076efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c076efa",
  null
  
)

export default component.exports